import { render, staticRenderFns } from "./adjektiv-stark-svag-bojning.vue?vue&type=template&id=69d06cec&scoped=true"
import script from "./adjektiv-stark-svag-bojning.vue?vue&type=script&lang=js"
export * from "./adjektiv-stark-svag-bojning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d06cec",
  null
  
)

export default component.exports